module.exports = __webpack_public_path__ + "static/collaboration-4a44d8f03ec44facdb781d6468de717e.svg";